import Message from "../messages/Message";
// Note to Pat:
    // I do not consider this long term code. It's a step above repeating error logic every time,
    // but a step below putting in place hands-free consistent error handling.
    // Love,
    // Dan
const errorResponseHandler = {
    generateErrorHandler: (callbacks = {}) => {
        return function (e) {
            if (e.type) {
                if (e.type === 'LIST' && callbacks.list) {
                    return callbacks.list(e);
                }

                if (e.type === 'RESPONSE' && callbacks.response) {
                    return callbacks.response(e);
                }
            } else {
                if (callbacks.other) {
                    return callbacks.other(e);
                }
            }

            new Message({
                body: e.message,
                isWarning: true,
            });
        };
    },
};
export default errorResponseHandler;
